// These are the strings used in the url indicating to the checkbox values
const HOOK = {
  CONNECTIONS: "conns",
  COUNTRY: "ctry",
  FAVOURITE: "fav",
  LSE_INDEX: "indx",
  INDUSTRY: "icb",
  NEWS_CATEGORY: "news",
  OTHER_INDEX: "othr",
  POSITION: "role",
  SEX: "sex",
  TENSE: "tns",
  COMPANY_TYPE: "typ",
  OFFICER_SEARCH: "osrh",
  COMPANY_SEARCH: "csrh",
  COMPANY_REG_TYPE: "crt",
  COMMITTEE: "cmt",
  EXEC: "exec", // Executive role
  INDP: "indp", // Independent role
  EVENT: "evnt", // Event type
  DELISTED: "dls",
}
export default HOOK